import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import { PageSizeSelectDropdown } from './PageSizeSelectDropdown';

const StyledWrapper = styled.div(({
  theme: {
    colors,
    fonts,
  },
}) => ({
  ...fonts.DEFAULT,
  color: colors.NEUTRAL_DEFAULT,
}));

export type PageSizeSelectProps = {
  /**
   * Порядковый номер первого элемента
   */
  start: number;
  /**
   * Порядковый номер последнего элемента
   */
  end: number;
  /**
   * Общее количество элементов
   */
  count: number;

  /**
   * Выбранное значение
   */
  value: number;
  /**
   * Список возможных значений
   */
  options?: number[];

  /**
   * Обработчик изменения значения
   * @param {number} nextValue - новое значение
   */
  onChange: (nextValue: number) => void;

  /**
   * id кнопки открытия/закрытия меню
   */
  toggleButtonId?: string;

  /**
   * id корневого элемента
   */
  wrapperId?: string;
};

const defaultOptions = [20, 40, 100];

export function PageSizeSelect({
  start,
  end,
  count,
  value,
  options = defaultOptions,
  onChange,
  toggleButtonId = '',
  wrapperId = '',
}: PageSizeSelectProps): ReactElement {
  return (
    <StyledWrapper
      id={wrapperId}
    >
      <PageSizeSelectDropdown
        value={value}
        options={options}
        onChange={onChange}
        toggleButtonId={toggleButtonId}
      >
        {start}
        &mdash;
        {end}
      </PageSizeSelectDropdown>
      {' '}
      из
      {' '}
      {count}
    </StyledWrapper>
  );
}
